import { UserType } from '../core/models/user';
import { Component, OnInit, inject } from '@angular/core';
import { AccountService } from '../core/services/account.service';
import { Token } from '../core/models/token';
import { ActionType } from '../core/models/premissions.model';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { NavButtonMenuComponent, NavOption } from '../nav-button-menu/nav-button-menu.component';

@Component({
    selector: 'app-nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.scss'],
    imports: [RouterLink, RouterLinkActive, MatButton, NavButtonMenuComponent]
})
export class NavBarComponent implements OnInit {
  accountService = inject(AccountService);

  isLoggdIn = false;
  UserType = UserType;
  actionType = ActionType;
  projectNavMenuOptions: NavOption[] = [];
  timeNavMenuOptions: NavOption[] = [];

  ngOnInit(): void {
    this.accountService.token.subscribe(x => {
      this.isLoggdIn = this.ChekisLoggdIn(x);
      this.rebuildProjectNavMenuOptions();
      this.rebuildTimeNavMenuOptions();
    });
    this.rebuildProjectNavMenuOptions();
    this.rebuildTimeNavMenuOptions();
  }

  logout() {
    this.accountService.logout();
  }

  ChekisLoggdIn(token: Token) {
    // console.log('ChekisLoggdIn');
    // console.log(token);
    if (token && token.experation) {
      return true;
    }
    return false;
  }

  showIfIsInUserType(userTypes: UserType[]): boolean {
    const index = userTypes.findIndex(x => x === this.accountService.userType);
    if (index > -1){
      return true;
    } else{
      return false;
    }
  }

  /** Matches `app-routing` /project RoleGuard (SysAdmin, CustomerUser, DeveloperUser). */
  showProjectNavMenu(): boolean {
    return this.showIfIsInUserType([UserType.SysAdmin, UserType.CustomerUser, UserType.DeveloperUser]);
  }

  /** Matches `app-routing` /customers RoleGuard. */
  showCustomersNavMenu(): boolean {
    return this.showIfIsInUserType([UserType.SysAdmin, UserType.DeveloperUser, UserType.ProductUpdator]);
  }

  private rebuildTimeNavMenuOptions(): void {
    const items: NavOption[] = [];
    if (this.showIfIsInUserType([UserType.SysAdmin, UserType.CustomerUser, UserType.TimeReportingUser])) {
      items.push({ name: 'Min tid', route: '/time/min' });
    }
    if (this.showIfIsInUserType([UserType.SysAdmin, UserType.CustomerUser, UserType.PunchClockUser])) {
      items.push({ name: 'Projektplats (iPad)', route: '/time/plats' });
    }
    if (this.showIfIsInUserType([UserType.SysAdmin, UserType.CustomerUser])) {
      items.push({ name: 'Fordon', route: '/time/fordon' });
      items.push({ name: 'Personal & fordon', route: '/time/personal' });
    }
    if (this.showIfIsInUserType([UserType.SysAdmin, UserType.CustomerUser, UserType.DeveloperUser, UserType.ProductUpdator])) {
      items.push({ name: 'Teamtid (godkännande)', route: '/time/team' });
    }
    this.timeNavMenuOptions = items;
  }

  private rebuildProjectNavMenuOptions(): void {
    const items: NavOption[] = [
      { name: 'Projekt', route: '/project/projects-list' },
    ];
    items.push(
      { name: 'Projekt platser', route: '/project/locations/1' },
      { name: 'Almänna Platser', route: '/project/locations/2' },
      { name: 'Board (välj projekt)', route: '/project/projects-list' },
      {
        name: 'Projektdetaljer (dummy)',
        route: '/project/projects-editor/-1',
        subOptions: [
          { name: 'Översikt', route: '/project/projects-editor/-1' },
          { name: 'Board', route: '/project/projects-editor/-1/board' },
          { name: 'Tid', route: '/project/projects-editor/-1/time' },
          { name: 'Inköp', route: '/project/projects-editor/-1/purchases' },
          { name: 'Leverantörsfakturor', route: '/project/projects-editor/-1/supplier-invoices' },
          { name: 'Att fakturera', route: '/project/projects-editor/-1/to-bill' },
          { name: 'Filer', route: '/project/projects-editor/-1/files' },
          { name: 'Kundkonversation', route: '/project/projects-editor/-1/customer-conversation' },
          { name: 'Aktivitetslogg', route: '/project/projects-editor/-1/activity' },
          { name: 'Inställningar', route: '/project/projects-editor/-1/settings' },
        ],
      }
    );
    this.projectNavMenuOptions = items;
  }
}
